import { Injectable } from '@angular/core';
import { ITableData } from '../../core/models/table';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { POSMaterialSaveObject, POSMaterialTableItem } from '../models/POSMaterials/POSMaterial';

const ROOT_URL: string = '/api/v1/pos-materials/';

@Injectable({
	providedIn: 'root'
})
export class POSMaterialsService {

	constructor(private http: HttpClient) {}

	public copy(id: number): Observable<POSMaterialSaveObject> {
		return this.http.post<POSMaterialSaveObject>(`${ROOT_URL}${id}/clone/`, {});
	}

	public create(params: Partial<POSMaterialSaveObject>): Observable<POSMaterialSaveObject> {
		return this.http.post<POSMaterialSaveObject>(ROOT_URL, params);
	}

	public delete(id: number): Observable<void> {
		return this.http.delete<void>(`${ROOT_URL}${id}/`);
	}

	public getTable(params: any): Observable<ITableData<POSMaterialTableItem>> {
		return this.http.get<ITableData<POSMaterialTableItem>>(ROOT_URL, { params: new HttpParams({ fromObject: params }) });
	}

	public update(id: number, data: Partial<POSMaterialSaveObject>): Observable<POSMaterialSaveObject> {
		return this.http.patch<POSMaterialSaveObject>(`${ROOT_URL}${id}/`, data);
	}
}
